/**
 * Countdown Timer JavaScript
 * This script updates the countdown timer based on the target time in the data attribute.
 */
jQuery(document).ready(function() {

    jQuery('.countdown-hero__timer').each(function(i, countdownContainer) {
        const targetDateString = jQuery(countdownContainer).attr('data-target-time');

        if (!targetDateString) return;

        const targetDate = moment.tz(targetDateString, "America/Los_Angeles");

        const daysElement = jQuery(countdownContainer).find('.countdown-hero__timer-slot--days strong');
        const hoursElement = jQuery(countdownContainer).find('.countdown-hero__timer-slot--hours strong');
        const minutesElement = jQuery(countdownContainer).find('.countdown-hero__timer-slot--minutes strong');

        function updateCountdown() {
            const currentDate = moment().tz("America/Los_Angeles");

            const timeDifference = targetDate.diff(currentDate);

            if (timeDifference <= 0) {
                daysElement.text('0');
                hoursElement.text('0');
                minutesElement.text('0');
                return;
            }

            const duration = moment.duration(timeDifference);
            const days = Math.floor(duration.asDays());
            const hours = duration.hours();
            const minutes = duration.minutes();

            daysElement.text(days);
            hoursElement.text(hours);
            minutesElement.text(minutes);
        }

        updateCountdown();

        setInterval(updateCountdown, 60000);
    });

});